'use strict';

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* global __PATH_PREFIX__ */
var lunr = require('lunr');

var _require = require('./common.js'),
    enhanceLunr = _require.enhanceLunr;

exports.onClientEntry = function (args, _ref) {
    var languages = _ref.languages;

    enhanceLunr(lunr, languages);
    fetch(__PATH_PREFIX__ + '/search_index.json').then(function (response) {
        return response.json();
    }).then(function (fullIndex) {
        window.__LUNR__ = (0, _keys2.default)(fullIndex).reduce(function (prev, key) {
            return (0, _assign2.default)({}, prev, (0, _defineProperty3.default)({}, key, { index: lunr.Index.load(fullIndex[key].index), store: fullIndex[key].store }));
        }, {});
    }).catch(function (e) {
        return console.log('Failed fetch search index');
    });
};